<template>
    <div
        class="mp-dock-center-region"
        :data-dock-host-id="CENTER_REGION_ID"
        data-dock-host-type="center"
        data-dock-host-label="Center"
    >
        <DockLayoutRenderer v-if="node" :node="node" />
        <div v-else class="mp-dock-center-placeholder text-grey-6">
            Drop panels here
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { CENTER_REGION_ID } from './constants.js';

export default {
    name: 'DockCenterRegion',
    components: {
        DockLayoutRenderer: defineAsyncComponent(() =>
            import('./DockLayoutRenderer.vue'),
        ),
    },

    props: {
        node: { type: Object, default: null },
    },

    data() {
        return { CENTER_REGION_ID };
    },
};
</script>
